import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    root: {},

    animated: {
      animation: '$rotate 2s linear infinite',
      pointerEvents: 'none',
      opacity: 0.5,
    },

    '@keyframes rotate': {
      '0%': {
        transform: 'rotate(0deg)',
      },
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
  });
